import AddIcon from '@mui/icons-material/Add';
import { Button, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import AddNewRole from './addNewRole.component';
import { useTranslation } from 'react-i18next';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1, 0, 3),
}));

export default function RolesToolbar({ handleSuccess }) {
  const { t: translate } = useTranslation();
  const [openNewRoleModel, setNewRoleModel] = useState(false);
  const handleNewRoleModal = () => {
    setNewRoleModel(true);
  };
  const handleClose = () => {
    setNewRoleModel(false);
  };
  return (
    <>
      <StyledRoot>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleNewRoleModal}>
          {translate('manage_brand.manage_roles.add_new_role')}
        </Button>
      </StyledRoot>
      {openNewRoleModel && <AddNewRole handleClose={handleClose} handleSuccess={handleSuccess} />}
    </>
  );
}
